import {styled} from "@mui/material";

export const FakeLink = styled("div")(() => ({
    textDecoration: "underline",
    cursor: "pointer",

    "&:hover": {
        opacity: 0.8,
    }
}))